module.exports = __webpack_public_path__ + "static/rcc-581-study-characteristics-mobile-d32e02029aac2233105cbf13c701bfd1.png";